import React from "react";

export const updateFn = <T>(setState: React.Dispatch<React.SetStateAction<T>>) => {
  return (partial: Partial<T>) => {
    setState((prev) => ({ ...prev, ...partial }));
  };
};
